const menuTrigger = document.getElementById('mobileMenuTrigger');
const menuWrapper = document.querySelector('.header nav');

function toggleMobileMenu() {
  menuTrigger?.classList.toggle('active');
  menuWrapper?.classList.toggle('active');
  document.body.classList.toggle('mobileScroll');
}

menuTrigger?.addEventListener('click', toggleMobileMenu);
